import { render } from "./SimpleTableRow.vue?vue&type=template&id=51a8617b&scoped=true"
import script from "./SimpleTableRow.vue?vue&type=script&lang=js"
export * from "./SimpleTableRow.vue?vue&type=script&lang=js"

import "./SimpleTableRow.vue?vue&type=style&index=0&id=51a8617b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a8617b"]])

export default __exports__